import type WebMap from '@arcgis/core/WebMap';

import type { WebMap as WebMapConfigType } from '@/common/overmind/namespaces/arcgis/config/config.types';

import apiFactory from '../../api/apiFactory';
import type { FeatureWithIDs, LayerId } from '../baseadapter';
import type { ArcgisMapServerConfig } from './ArcgisMapAdapter';
import { ArcgisMapAdapter } from './ArcgisMapAdapter';
import { getTitlesFromWebMap, getWebMap } from './getWebMapTitles';

let adapter: ArcgisMapAdapter | undefined;

export default {
  initializeAdapter(
    serverConfig: ArcgisMapServerConfig,
    options: {
      onConfiguredToken: () => void;
      shouldUseTokenRefreshing: () => boolean;
      routeToRedirectUri: () => void;
      portalUrl: string | undefined,
      sharingUrl: string | undefined,
      restServicesUrl: string | undefined,
      apiFactory?:  typeof apiFactory
    }
  ): ArcgisMapAdapter {
    const _apiFactory = options.apiFactory || apiFactory;
    const createApi = () =>
      _apiFactory({ baseURL: serverConfig.baseUrl }, 'Param');
    adapter = new ArcgisMapAdapter(serverConfig, { createApi, ...options });
    return adapter;
  },
  getAdapter() {
    return adapter;
  },
  createWebMap(webMapConfig: WebMapConfigType) {
    return getWebMap(webMapConfig);
  },
  createTitleRetrievingFunction(webMap: WebMap) {
    return (featuresWithIds: FeatureWithIDs<unknown>[]) =>
      getTitlesFromWebMap(featuresWithIds, webMap);
  },
  createFindLayerName(webMap: __esri.WebMap) {
    return (layerId: LayerId) => {
      const table = webMap.allTables
        .toArray()
        .find(table => table.layerId === layerId);
      if(table) {
        return table.title;
      }
      const layers = webMap.allLayers
        .toArray()
        .flatMap(layer => {
          if (layer.type === 'subtype-group') {
            const group = layer as __esri.SubtypeGroupLayer;
            const layers = group.sublayers
              .toArray()
              .map(subLayer => ({ layerId: subLayer.parent.layerId, name: subLayer.title }));
  
            return layers;
          }
  
          return { layerId: layer.layerId, name: layer.title };
        });
        const layer = layers
        .find(layer => layer.layerId === layerId)
  
      if(layer) {
        return layer.name
      }
  
      return null
    }
  }
};
